import axios from 'axios';
import _ from 'lodash'
import { usePermissionStore } from '../../pinia/PermissionStore';
// initial state
// shape: [{ id, quantity }]
const state = () => ({
    list : [],
    loaded : false,
    addNew : false,
    columns : [
      {
        table : "groups",
        direction : "ASC",
        direction_pos : 0,

        key : "name",
        label : "name",
        display : true
    },
    ],
    workingOn: [],
    isSavingNew : false,
    infinity : {
        clear: false,
        search : "",
        columns : ['name'],
        allLoaded : false,
        loading : false,
        loadingMore : false,
        take : 50,
    },
    pagination: {
        currentPage: 1,
        totalPageCount: 0,
        pagesize: 5
    },
})

  // getters
  const getters = {
      id : (state) => (id) => {
        return state.list[state.list.findIndex(item => item.id == id)]
      }
  }

  // actions
  const actions = {
    async load({commit, state, rootState}){
        const permissionStore = usePermissionStore();
        if(state.infinity.allLoaded == false && state.infinity.loading == false){
            commit("infinityLoading", true);
            if(state.infinity.clear == true){
                var skip = 0;
            }else{
                var skip = state.list.length;
            }
            await axios.get(rootState.settings.url + "/api/v1/"+rootState.settings.internal.user_company +"/groups", {params : {search : state.infinity.search, take: state.infinity.take, skip : skip, columns : state.infinity.columns, table_columns: state.columns}}).then((response) => {
                commit("set", response.data.data);
                permissionStore.data = response.data.meta.permissions;
                commit("loaded", true);
                commit("infinityLoading", false);
            });
        }
    },
    async update({ commit, state, rootState }, data) {
        await axios.put(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/groups/" + data.id, data).then(response => {
            commit("update", response.data.data);
        })
    },
    async store({ commit, state, rootState }, data) {
        await axios.post(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/groups", data).then(response => {
            commit("unshift", response.data.data);
        })
    },
    async delete({commit, state, rootState}, data){
        await axios.delete(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/groups/" + data.id).then(response => {
            commit("removeId", response.data.deleted);
        })
    }
  }

  // mutations
  const mutations = {
    removeId(state, id){
        var index = state.list.findIndex(item => item.id == id);
        if(index >= 0){
            state.list.splice(index, 1);
        }
    },
      clean(state){
        state.list = [];
        state.infinity.allLoaded = false;
        state.loaded = false;
        state.workingOn = [];
      },
      update(state, element) {
        var index = state.list.findIndex(item => item.id == element.id);
        state.list[index] = element;
    },
        addCompany(state, load){
            state.addNew = load;
        },
        store(state, company){
            state.list.unshift(company);
        },
        unshift(state, element){
            state.list.unshift(element);
        },
      set(state, data){
          if(state.infinity.clear == true){
              state.data = [];
              state.allLoaded = false;
          }
          if(data == undefined || data.length < state.infinity.take){
              state.infinity.allLoaded = true;
          }
          state.list.push(...data);
          state.infinity.clear = false;
      },
      loaded(state, status){
          state.loaded = status;
      },
      isSavingNew(state, status){
          state.isSavingNew = status;
      },
        setSearch(state, search){
            state.infinity.loading = true;
            state.infinity.allLoaded = false;
            state.infinity.search = search;
            state.infinity.clear = true;
        },
        infinityLoading(state, status){
            state.infinity.loading = status;
        },
        setSearchValue(state, value){
            state.infinity.search = value;
        },
        updateColumn(state, column){
            var index = state.columns.findIndex(item => item.key == column.key)
            for(let i in state.columns){
                state.columns[i].direction_pos += 1;
            }
            if(index > -1){
                column.direction_pos = 0;
                state.columns[index] = column;
            }
        }
  }

  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    modules: {
    }
  }
